import React from 'react';

import PropTypes from 'prop-types';
import { Divider, Typography } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';
import FilesListRow from './filesListRow';

const FilesList = ({ filesList, removeFileFromList, orderId }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    general: { fileListLabel }
  } = localizedStrings;

  return (
    <>
      <Divider space={2} variant={{ inverse: true }} />
      <div className="card">
        <div className="card-header">
          <Typography heading="h4" variant={{ size: 'h4' }} block>{fileListLabel}</Typography>
        </div>
        <ul className="list-group list-group-flush">
          {filesList.map(file => (
            <FilesListRow
              key={file.fileId}
              orderId={orderId}
              fileData={file}
              removeFileFromList={removeFileFromList}
            />
          ))}
        </ul>
      </div>
    </>
  );
};

FilesList.propTypes = {
  filesList: PropTypes.arrayOf(PropTypes.object).isRequired,
  removeFileFromList: PropTypes.func.isRequired,
  orderId: PropTypes.number.isRequired
};

export default FilesList;
